import { render, staticRenderFns } from "./armoireEmpty.vue?vue&type=template&id=5dcf8530&scoped=true&"
import script from "./armoireEmpty.vue?vue&type=script&lang=js&"
export * from "./armoireEmpty.vue?vue&type=script&lang=js&"
import style0 from "./armoireEmpty.vue?vue&type=style&index=0&id=5dcf8530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcf8530",
  null
  
)

export default component.exports